export default __webpack_public_path__ + "static/media/blog-2.d92785ec.jpg";